<div id="extract-text-web" class="m-3">
    <h2 class="mb-3">Extraer texto de páginas web</h2>

    <div id="text-source">
        <label for="extract-text-web-source" class="d-block">
            <p class="fw-bold">Sitio web del cual extraer contenido:</p>
            <input id="extract-text-web-source" class="form-control" type="url" size="100" [(ngModel)]="webUrl">
        </label>
    </div>

    <div id="text-plain">
        <label for="extract-text-web-plain" class="d-block">
            <span class="fw-bold">¿Borrar formato original del contenido?</span>
            <input id="extract-text-web-plain" class="ms-3" type="checkbox" [(ngModel)]="plain">
        </label>
    </div>

    <div id="extract-text-web-status" class="mt-3">
        <div id="extract-text-web-spinner" *ngIf="webExtracting">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Procesando, espere por favor...</span>
        </div>
        <div id="extract-text-web-error" class="text-danger" *ngIf="webExtractError">
            <i class="fa fa-times"></i>
            <span>{{ webExtractResultText }}</span>
        </div>
        <div id="extract-text-web-success" class="text-success" *ngIf="webExtractSuccess">
            <i class="fa fa-check"></i>
            <span>{{ webExtractResultText }}</span>
            <!-- Ahora será redireccionado, espere un momento... -->
        </div>
    </div>

    <div id="extract-text-web-buttons" class="row mt-3">
        <button class="btn btn-primary ms-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
            <i class="fa fa-arrow-left"></i>
            <span>Volver</span>
        </button>
        <button class="btn btn-success ms-3" [attr.disabled]="webExtracting ? 'disabled' : null" (click)="extractTextWeb()">
            <i class="fas fa-globe"></i>
            <i class="fas fa-align-center"></i>
            <span>Extraer texto</span>
        </button>
    </div>

    <div id="extract-text-web-result" class="mt-3" *ngIf="webExtractSuccess && webContent.length > 0">
        <h4>Resultado:</h4>

        <div id="result-title">
            <p class="fw-bold">Título:</p>
            <input id="extract-text-web-result-title" class="form-control" type="text" size="100" [(ngModel)]="webContentTitle">
        </div>
        
        <div id="result-content" class="mt-3">
            <p class="fw-bold">Contenido:</p>
            <tinymce-editor [id]="webContentEditorId" [content]="webContent" [focus]="false"></tinymce-editor>
        </div>

        <div id="result-next-step" class="mt-3">
            <div id="result-next-step-options">
                <p class="fw-bold">¿Qué desea hacer con el contenido?</p>
                <label for="next-step-new-lesson" class="d-block">
                    <input type="radio" name="next-step" id="next-step-new-lesson" [(ngModel)]="nextStep" value="new-lesson">
                    <span class="ms-1">Crear nueva lección y enunciado</span>
                </label>
                <label for="next-step-new-heading" class="d-block">
                    <input type="radio" name="next-step" id="next-step-new-heading" [(ngModel)]="nextStep" value="new-heading">
                    <span class="ms-1">Crear nuevo enunciado en lección existente</span>
                </label>
                <label for="next-step-replace" class="d-block">
                    <input type="radio" name="next-step" id="next-step-replace" [(ngModel)]="nextStep" value="replace">
                    <span class="ms-1">Insertar en enunciado existente, reemplazando contenido existente</span>
                </label>
                <label for="next-step-top" class="d-block">
                    <input type="radio" name="next-step" id="next-step-top" [(ngModel)]="nextStep" value="top">
                    <span class="ms-1">Insertar en enunciado existente, encima del contenido existente</span>
                </label>
                <label for="next-step-bottom" class="d-block">
                    <input type="radio" name="next-step" id="next-step-bottom" [(ngModel)]="nextStep" value="bottom">
                    <span class="ms-1">Insertar en enunciado existente, debajo del contenido existente</span>
                </label>
            </div>

            <div id="result-next-step-destination" *ngIf="nextStep != ''">
                <label for="course-units" class="d-block" *ngIf="courseUnits.length > 0">
                    <p class="fw-bold">Unidad:</p>
                    <select name="course-units" id="course-units" [(ngModel)]="selectedUnit" (ngModelChange)="selectUnit($event)">
                        <option disabled selected value="-1">Seleccione una unidad...</option>
                        <option *ngFor="let unit of courseUnits" [value]="unit.id">
                            {{ unit.name }}
                        </option>
                    </select>
                </label>

                <label for="new-lesson-name" class="d-block" *ngIf="nextStep == 'new-lesson' && selectedUnit != -1">
                    <span class="fw-bold">Nombre de la nueva lección:</span>
                    <input id="new-lesson-name" class="form-control mt-3" type="text" [(ngModel)]="newLessonName">
                </label>

                <label for="units-lessons" class="d-block" *ngIf="nextStep != 'new-lesson' && unitLessons.length > 0">
                    <p class="fw-bold">Lección:</p>
                    <select name="unit-lessons" id="unit-lessons" [(ngModel)]="selectedLesson" (ngModelChange)="selectLesson($event)">
                        <option disabled selected value="-1">Seleccione una lección...</option>
                        <option *ngFor="let lesson of unitLessons" [value]="lesson.id">
                            {{ lesson.name }}
                        </option>
                    </select>
                </label>
            
                <label for="lesson-headings" class="d-block" *ngIf="(nextStep != 'new-lesson' && nextStep != 'new-heading') && lessonHeadings.length > 0">
                    <p class="fw-bold">Enunciado:</p>
                    <select name="lesson-headings" id="lesson-headings" [(ngModel)]="selectedHeading" (ngModelChange)="selectHeading($event)">
                        <option disabled selected value="-1">Seleccione un enunciado...</option>
                        <option *ngFor="let heading of lessonHeadings" [value]="heading.id">
                            {{ heading.name }}
                        </option>
                    </select>
                </label>
            </div>

            <div id="result-next-step-status" class="mt-3">
                <div id="result-next-step-spinner" *ngIf="nextStepLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span>Procesando, espere por favor...</span>
                </div>
                <div id="result-next-step-error" class="text-danger" *ngIf="nextStepError">
                    <i class="fa fa-times"></i>
                    <span>Ha habido un error. Por favor, inténtelo de nuevo.</span>
                </div>
                <div id="result-next-step-success" class="text-success" *ngIf="nextStepSuccess">
                    <i class="fa fa-check"></i>
                    <span *ngIf="nextStep == 'new-lesson'">Se han creado la nueva lección y el nuevo enunciado exitosamente.</span>
                    <span *ngIf="nextStep == 'new-heading'">Se ha creado el nuevo enunciado exitosamente.</span>
                    <span *ngIf="nextStep != 'new-lesson' && nextStep != 'new-heading'">Se ha actualizado el enunciado exitosamente.</span>
                    <!-- Ahora será redireccionado, espere un momento... -->
                </div>
            </div>

            <div id="result-next-step-buttons" class="row mt-3" *ngIf="nextStep != ''">
                <button class="btn btn-primary ms-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
                    <i class="fa fa-arrow-left"></i>
                    <span>Volver</span>
                </button>
                <button class="btn btn-success ms-3" [attr.disabled]="(nextStep == 'new-lesson' && (selectedUnit == -1 || newLessonName == '')) || (nextStep == 'new-heading' && (selectedUnit == -1 || selectedLesson == -1)) || (nextStep != 'new-lesson' && nextStep != 'new-heading' && selectedHeading == -1) ? 'disabled' : null"
                    (click)="extractTextWebNextStep()">
                    <i class="fas fa-align-center"></i>
                    <span *ngIf="nextStep == 'new-lesson'">Crear lección y enunciado</span>
                    <span *ngIf="nextStep == 'new-heading'">Crear enunciado</span>
                    <span *ngIf="nextStep != 'new-lesson' && nextStep != 'new-heading'">Actualizar enunciado</span>
                </button>
            </div>
        </div>

    </div>
</div>